import { StyledDiv, StyledSpan } from '../Theme/CommonStyled';
import i18n from '../Locales/i18n';
import { fixLocaleString } from './common.util';
export const tableTitles = {
  warE_NAME_VC: i18n.t('facture.factureTable.foodName'),
  wareCount: (
    <StyledDiv textAlign="center">
      {i18n.t('facture.factureTable.count')}
    </StyledDiv>
  ),
  warE_PRICE_IN: (
    <StyledDiv textAlign="center">
      {i18n.t('facture.factureTable.price')}
    </StyledDiv>
  )
};

export const columnRenderer = {
  warE_NAME_VC: (value) => (
    <StyledDiv color="normalText" fontSize={0}>
      {value}
    </StyledDiv>
  ),
  wareCount: (value) => (
    <StyledDiv color="secondaryText" textAlign="center" fontSize={2}>
      {value}
    </StyledDiv>
  )
};

export const tableColumns = (currency: string) =>
  ['warE_NAME_VC', 'wareCount', 'warE_PRICE_IN'].map((item) => ({
    title: tableTitles[item],
    dataIndex: item,
    width: item === 'warE_NAME_VC' ? 250 : item === 'wareCount' ? 50 : 100,
    key: item,
    render:
      item === 'warE_PRICE_IN'
        ? (value) => (
            <StyledDiv textAlign="left" fontSize={2} color="normalText">
              {fixLocaleString(value)}
              <StyledSpan fontSize="0.8rem" color="minorText" mr={3}>
                {currency}
              </StyledSpan>
            </StyledDiv>
          )
        : columnRenderer[item]
  }));
